export function fullNameMinLength() {
  return 2;
}
